<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centernews") }}</h4>
        </div>
      </div>
    </div>

    <!--content start-->
    <div id="board02_wrap">
      <div class="grab">
        <div class="board02_row" v-for="news in board">
          <div class="board02_ma" typeof="button" v-on:click="goDetail(news.no)">
          <div class="board02_image" v-bind:class="{none:(news.thumbnail.length==0)}"><!--!@#-->
            <img v-bind:src="news.thumbnail">
          </div>
          <div class="board02_body" v-bind:class="{none:(news.thumbnail.length==0)}"><!--!@#-->
            <p class="board02_title">{{$t(news.title)}}</p>
            <p class="board02_content"> <span v-html="news.summary"></span></p>
            <p class="board02_date">{{$t(news.date)}}</p>
          </div>
          </div>
          <div class="admin-button-group" v-if="login_state">
            <button class="edit-button"  v-on:click="editItem(news.no)">{{ $t("edit") }}</button>
            <button class="del-button" v-on:click="deleteItem(news.no)">{{ $t("delete") }}</button>
          </div>
        </div>

        <button class="add-button" v-if="login_state" v-on:click="addItem()">{{ $t("write") }}</button>

        <!--<button class="add-button" v-if="login_state" v-on:click="update(page_no)">업데이트</button>-->


        <!--page navigation-->
        <nav>

          <paginate ref="pagebuttons"
                    v-model = "page_no"
                    :page-count="page_count"
                    :page-range="7"
                    :margin-pages="3"
                    :click-handler="pageChanged"
                    :prev-text="'이전'"
                    :next-text="'다음'"
                    :container-class="'pagination'"
                    :page-class = "'page-item'"
          ></paginate>


          <!--<ul class="pagination">
            <li class="disabled"><a href="#" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
            <li class="active"><a href="#">1 <span class="sr-only">(current)</span></a></li>
            <li><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li><a href="#">4</a></li>
            <li><a href="#">5</a></li>
            <li>
              <a href="#" aria-label="Next" v-on:click="update(1)">
                <span aria-hidden="true">AAAAAAAAAAAAAAA</span>
              </a>
            </li>
          </ul>-->
        </nav>
      </div>
    </div>


  </div>
</template>
<script>
  import api from '../api/api'
  import Paginate from 'vuejs-paginate'
  import { mapState } from 'vuex'

  export default {
    name: 'NoticeNews',
    components : {Paginate},
    data: function () {
      return {
        page_no:1,
        page_count:1,
        board: []
        /*board: [
          {
            no : 1,
            thumbnail : 'http://mimgnews1.naver.net/image/109/2016/11/03/201611030735776051_581a6b4fe4d26_99_20161103075805.jpg?type=w540',
            title: '수도권 고밀도 관측망을 활용한 위험기상감시 효과성 연구',
            summary: "간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1간단한 상세 내용이 나온다.1",
            date: '2018-09-11'
          },
          {
            no : 2,
            thumbnail : 'http://mimgnews2.naver.net/image/109/2016/11/03/201611030735776051_581a6b5319cb9_99_20161103075805.jpg?type=w540',
            title: '지상기반 원격탐사장비를 이용한 도시대기경계층고도의 산정 및 DB 작성',
            summary: "간단한 상세 내용이 나온다.2",
            date: '2018-09-1'
          }
        ]*/
      }
    },
    created: function ()
    {
    },
    mounted: function() {
      console.log('## 12343')
      this.update(1)
    },
    computed: _.extend({
      test: function ()
      {
      }
    },mapState(['user_name' , 'login_state'])),
    methods : {
      pageChanged : function(no)
      {
        console.log('## page no : ' + no)
        this.update(no)

      },
      goDetail: function (no) {
        console.log('## goDetail : function() ' + no  )
        this.$router.push({name: "noticedetail" , params:{type:0,contentsNo:no} })
      },
      editItem : function(no){
        console.log('xx edit ' + no)
        // Trigger an Alert dialog
        this.$router.push({name: "noticewrite" , params:{type:0,contentsNo:no} })
      },
      deleteItem: function(no) {
        console.log('xx delete ' + no)
        if (confirm(this.$t("message_delete"))) {
          console.log("You pressed OK!");
          api.delete(no).then((response) => {
            if (response.data.status === 'success') {
              this.update(this.page_no)
            }
            else {
              console.log('## 3 ' + JSON.stringify(response.data));
              alert('에러 : ' + response.data.message)
            }
          })
        } else {
          console.log("You pressed Cancel!");
        }
      },
      addItem : function() {
        console.log('xx aa ')
        this.$router.push({name: "noticewrite" , params:{type:0,contentsNo:0} })
      },
      update : function(page_no)
      {
        api.reqList(1 , '5' , page_no )
          .then((response) => {
            console.log('## 3 ' + JSON.stringify(response.data));
            console.log('## 32 ' + 'done')

            if (response.data.status === 'success') {
              this.board = response.data.items;
              this.page_no = response.data.page_no;
              this.page_count = response.data.page_count;
            }
            else {
              console.log('## 3 ' + JSON.stringify(response.data));
              alert('에러 : ' + response.data.message)
            }

          })

      }
    }
  }
</script>

<style scoped>
  /*@import url("https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.5/css/bootstrap.css");*/
</style>



// WEBPACK FOOTER //
// src/components/NoticeNews.vue